import { createTheme } from 'components/base/system/theme';
import { baseTheme } from './base';
import { custom1, custom2, other } from 'assets';

export const createButtonTheme = createTheme({
  palette: baseTheme.palette,
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },

      styleOverrides: {
        root: {
          fontSize: '0.875rem',
          fontFamily: 'Roboto',
          fontWeight: 500,
          padding: '5px 16px',
          textTransform: 'none',
        },
        startIcon: {
          '& > div': {
            fontSize: '12px !important',
          },
        },

        containedPrimary: {
          color: baseTheme.palette.primary.main,
          backgroundColor: baseTheme.palette.secondary.main,
          '&:disabled': {
            backgroundColor: `${custom2.main4} !important`,
            color: `${baseTheme.palette.normalText.light} !important`,
          },
        },
        outlined: {
          border: `1px solid ${other.border}`,
          '& svg': {
            marginRight: '0 !important',
          },
        },
        outlinedPrimary: {
          color: baseTheme.palette.secondary.main,
          border: `1px solid ${baseTheme.palette.secondary.main}`,
          '&:hover': {
            border: `1px solid ${baseTheme.palette.secondary.main}`,
          },
        },
        containedSecondary: {
          color: baseTheme.palette.primary.contrastText,
          border: `1px solid ${baseTheme.palette.primary.dark}`,
          backgroundColor: baseTheme.palette.primary.main,
          '&:hover': {
            border: `1px solid ${baseTheme.palette.primary.dark}`,
            backgroundColor: baseTheme.palette.primary.main,
            color: baseTheme.palette.primary.contrastText,
          },
          '&:disabled': {
            backgroundColor: '#0000001F !important',
            color: '#9E9E9EE5 !important',
          },
        },
        outlinedSecondary: {
          color: baseTheme.palette.primary.main,
          border: '1px solid #23375952',
          '&:hover': {
            border: '1px solid #23375952',
            backgroundColor: '#0000000D',
          },
          '&:disabled': {
            backgroundColor: '#0000001F !important',
            color: '#9E9E9EE5 !important',
          },
        },
        textSecondary: {
          color: baseTheme.palette.primary.main,
          border: 'none',
          backgroundColor: baseTheme.palette.primary.contrastText,
          '&:hover': {
            border: 'none',
            backgroundColor: '#0000000D',
            color: baseTheme.palette.primary.main,
          },
          '&:disabled': {
            backgroundColor: '#0000001F !important',
            color: '#9E9E9EE5 !important',
          },
        },
        textPrimary: {
          color: baseTheme.palette.secondary.main,
          border: 'none',
          backgroundColor: 'transparent !important',
          '&:hover': {
            border: 'none',
            backgroundColor: 'transparent !important',
            color: baseTheme.palette.secondary.main,
          },
          '&:disabled': {
            backgroundColor: '#0000001F !important',
            color: '#9E9E9EE5 !important',
          },
        },
        containedError: {
          backgroundColor: `${baseTheme.palette.error.main} !important`,
          color: `${baseTheme.palette.common.white} !important`,
          '&:disabled': {
            backgroundColor: `${baseTheme.palette.error.background} !important`,
            color: `${baseTheme.palette.error.light} !important`,
          },
        },
        outlinedError: {
          color: baseTheme.palette.error.main,
          border: `1px solid ${baseTheme.palette.error.main}`,
          '&:hover': {
            border: `1px solid ${baseTheme.palette.error.main}`,
          },
          '&:disabled': {
            backgroundColor: `${baseTheme.palette.error.background} !important`,
            color: `${baseTheme.palette.error.light} !important`,
          },
        },
        containedCustom1: {
          color: custom1.contrastText,
          backgroundColor: custom1.main,
          '&:hover': {
            backgroundColor: custom1.dark,
          },
          '&:disabled': {
            backgroundColor: `${custom2.main4} !important`,
            color: `${baseTheme.palette.normalText.light} !important`,
          },
        },
        outlinedCustom1: {
          color: custom1.main,
          border: `1px solid ${custom1.main}`,
          '&:hover': {
            border: `1px solid ${custom1.dark}`,
            backgroundColor: custom1.background,
          },
          '&:disabled': {
            backgroundColor: '#0000001F !important',
            color: '#9E9E9EE5 !important',
          },
        },
        textCustom1: {
          color: custom1.main,
          '&:hover': {
            backgroundColor: custom1.background,
          },
          '&:disabled': {
            color: '#9E9E9EE5 !important',
          },
        },
      },
    },
  },
});
